// The two-run rhythm of a test run: like the daily sync, a run only acts on changes since
// the run before it, so the first upload saves the starting point and the second one tests.
export const STEPS = [
  { title: 'Choose a property', hint: 'Then download its example file.' },
  { title: 'Save the starting point', hint: 'Upload the example file unchanged and run.' },
  { title: 'Test a change', hint: 'Edit the file the way Entrata would, upload it and run.' },
];

export const currentStep = ({ hasProperty, runs }) => {
  if (!hasProperty) {
    return 0;
  }

  return runs === 0 ? 1 : 2;
};
